export default __webpack_public_path__ + "static/media/HUD-Effects-06.0ea08cae.jpg";